<template>
  <!-- Ticking the Completed list first asks when, like the hike page's Completed button. -->
  <div v-if="askingDateFor" data-test="completed-date-step">
    <h3 class="mb-4"><strong>{{ $t('hikes.complete_modal_title') }}</strong></h3>
    <label for="lists_completed_at_input" class="form-label">{{ $t('hikes.complete_modal_label') }}</label>
    <input
      id="lists_completed_at_input"
      v-model="completedOn"
      type="date"
      class="form-control py-2 border-0"
      style="background: #17181d"
      :max="today"
      data-test="completed-date-input"
    >
    <div class="d-flex justify-content-end gap-2 mt-4">
      <button class="btn btn-outline-secondary" type="button" data-test="completed-date-cancel" @click="cancelCompletedDate">
        {{ $t('hikes.complete_modal_cancel') }}
      </button>
      <button class="btn btn-primary" type="button" :disabled="!completedAt" data-test="completed-date-confirm" @click="confirmCompletedDate">
        {{ $t('hikes.complete_modal_confirm') }}
      </button>
    </div>
  </div>
  <div v-else>
    <h3 class="mb-4"><strong>{{ $t('on_boarding.add_to_list_page.add_to_hike_list') }}</strong></h3>

    <div v-for="hikeList of this.usersHikeLists" :key="hikeList.id">
      <div class="row p-0 m-0">
        <div class="input-group col-12 p-0 m-0 d-flex align-items-center justify-content-between">
          <span class="py-2 border-0"><p class="m-0">{{hikeList.name}}</p></span>
          <span class="input-group-append">
          <button class="btn btn-block btn-link d-flex align-items-center" type="button" :disabled="hikeListIsPending(hikeList)" data-test="toggle-hike-list" @click="tapHikeList(hikeList)">
            <template v-if="hikeListIncludesHike(hikeList)">
              <span class="material-icons text-yellow">check</span>
            </template>
            <template v-else>
              <span class="material-icons text-muted">add</span>
            </template>
          </button>
        </span>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0">
          <hr class="my-1">
        </div>
      </div>
    </div>

    <div class="row p-0 m-0">
      <div class="input-group col-12 p-0 m-0 d-flex align-items-center">
        <input class="form-control py-2 border-0" style="background: #17181d" :placeholder="$t('on_boarding.add_to_list_page.create_a_new_list')" @keyup.enter="createHikeList" v-model="hikeListName">
        <span class="input-group-append">
          <button class="btn btn-block btn-link d-flex align-items-center" type="button" @click="createHikeList">
            <span class="material-icons text-muted">add</span>
          </button>
        </span>
      </div>
    </div>

    <div class="row p-0 m-0">
      <div class="col-12 p-0 m-0">
        <hr class="my-1">
      </div>
    </div>
    <!-- <button class="btn btn-primary" @click="closeClicked">Close</button> -->
  </div>
</template>

<script>

import { defineComponent } from 'vue';
import { asksForCompletedDate, isHikeInList, sameHikeId } from '../../../utils/helpers/hikeListMembership';
import { completedAtFromDateInput, todayDateInputValue } from '../../../utils/helpers/completedAt';

export default defineComponent({
  data() {
    return {
      hikeListName: '',
      // The Completed list while its date is being asked for; null otherwise.
      askingDateFor: null,
      completedOn: todayDateInputValue(),
      today: todayDateInputValue(),
    };
  },
  async mounted() {
    await this.$store.dispatch('onBoarding/getUserHikeLists');
  },
  computed: {
    usersHikeLists: {
      get() {
        return this.$store.state.onBoarding.usersHikeLists;
      },
    },
    hikeId: {
      get() {
        return this.$store.state.onBoarding.hikeId;
      },
    },
    completedAt() {
      return completedAtFromDateInput(this.completedOn, this.today);
    },
  },
  methods: {
    tapHikeList(hikeList) {
      if (asksForCompletedDate(hikeList, this.hikeId)) {
        this.today = todayDateInputValue();
        this.completedOn = this.today;
        this.askingDateFor = hikeList;
        return;
      }
      this.$store.dispatch('onBoarding/toggleHikeInList', hikeList);
    },
    confirmCompletedDate() {
      const { completedAt, askingDateFor: hikeList } = this;
      if (!completedAt || !hikeList) return;
      this.askingDateFor = null;
      this.$store.dispatch('onBoarding/completeHikeInList', { hikeList, completedAt });
    },
    cancelCompletedDate() {
      this.askingDateFor = null;
    },
    async createHikeList() {
      if (this.hikeListName === '') {
        return alert(this.$t('on_boarding.add_to_list_page.add_a_name_for_list'));
      }
      try {
        await this.$store.dispatch('onBoarding/createHikeList', this.hikeListName);
        this.hikeListName = '';
      } catch (e) {
        alert(e);
      }
    },
    async closeClicked() {
      this.$modal.classList.toggle('open');
    },
    hikeListIncludesHike(hikeList) {
      return isHikeInList(hikeList, this.hikeId);
    },
    hikeListIsPending(hikeList) {
      return this.$store.state.onBoarding.pendingHikeListIds.some((id) => sameHikeId(id, hikeList.id));
    },
  },
});
</script>

<style scoped>

</style>
